import {
    JOB_CATEGORY,
    UPDATE_CATEGORY,
    ENTITIES,
    CATEGORY_LIST
} from './ActionType'
import {
    END_POINT_GET_ENTITIES,
    END_POINT_GET_JOB_CATEGORIES
} from '../api/EndPoint'
import {
    GET_SUCCESS
} from '../api/ResponseType'
import axios from 'axios'


export const selectJobCategory = (category) => dispatch => {

    dispatch({
        type: JOB_CATEGORY,
        payload: category
    })

}

export const handleDelete = (categories) => dispatch => {
    dispatch({
        type: UPDATE_CATEGORY,
        payload: categories
    })
}

export const getEntities = () => dispatch => {

    axios(
        {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': true
            },
            withCredentials: false,
            mode: 'no-cors',
            url: END_POINT_GET_ENTITIES,
        }
    ).then( response => {

        if(response.status === GET_SUCCESS){
            dispatch({
                type: ENTITIES,
                payload: response.data.message.entities
            })
        }else{
            window.alert("RESPONSE ERROR!")
        }

    }).catch( error => {
       
        window.alert(error)

    })

}

export const getJobCategories = () => dispatch => {

    axios(
        {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': true
            },
            withCredentials: false,
            mode: 'no-cors',
            url: END_POINT_GET_JOB_CATEGORIES,
        }
    ).then( response => {

        if(response.status === GET_SUCCESS){
            dispatch({
                type: CATEGORY_LIST,
                payload: response.data.message.categories
            })
        }else{
            window.alert("RESPONSE ERROR!")
        }

    }).catch( error => {
       
        window.alert(error)

    })


}